import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

import ArrowIcon from '@material-ui/icons/PlayArrow';
import SearchIcon from '@material-ui/icons/Search';

import Icon from '@components/Icon/Icon';

import './FeatureBlock.scss';
import '@components/Link/Link.scss';

const FeatureBlock = ({ isMobile }) => (
  <div className="feature-block">
    <div className="feature-block__title">
      Setting the <span className="feature-block__highlight">precedent</span>
    </div>
    <div className="feature-block__content">
      {!isMobile && (
        <div className="feature-block__left-column">
          <div className="feature-block__bottom-arrow">
            <div className="feature-block__bottom-arrow-line" />
            <Icon className="feature-block__bottom-arrow-icon">
              <ArrowIcon />
            </Icon>
          </div>
          <div className="feature-block__right-arrow">
            <div className="feature-block__right-arrow-line" />
            <Icon className="feature-block__right-arrow-icon">
              <ArrowIcon />
            </Icon>
          </div>
        </div>
      )}
      <div className="feature-block__right-column">
        <div className="feature-block__text">
          Our progressive approach to problem solving
          inspires creative solutions that deliver optimal
          results to our clients.
        </div>
        <div className="feature-block__button-wrapper">
          <RouterLink
            to="/cases"
            className="link feature-block__link"
          >
            <div>
              Search cases
            </div>
            <Icon className="feature-block__icon">
              <SearchIcon />
            </Icon>
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
);

FeatureBlock.propTypes = {
  isMobile: PropTypes.bool.isRequired,
};

export default FeatureBlock;



// WEBPACK FOOTER //
// ./src/routes/Landing/components/FeatureBlock/FeatureBlock.js